/**
 * A band below the first screen skips layout and paint until the visitor
 * scrolls near it (`SITE-HOME02` part 3, `SITE-CRS02`). Every web font that
 * arrives re-lays out the whole page before its first paint, so on the slow
 * phone profile each band below the first screen cost the headline time. The
 * intrinsic size is a stand-in until the band has rendered once; `auto` keeps
 * its real height after that.
 */
export const BELOW_FOLD_BAND =
  "[content-visibility:auto] [contain-intrinsic-size:auto_1600px] lg:[contain-intrinsic-size:auto_900px]";

/** Marks a band `BelowFoldBands` renders after load and before an in-page jump. */
export const BELOW_FOLD_ATTRIBUTE = "data-below-fold";

/**
 * Renders every band that is still skipped. A band never rendered is laid out
 * at its stand-in height, so a jump to a section past it lands up to 2,000 px
 * off (measured on the course page); call this before any in-page scroll.
 */
export function renderBelowFoldBands(): void {
  for (const band of document.querySelectorAll<HTMLElement>(`[${BELOW_FOLD_ATTRIBUTE}=""]`)) {
    renderBelowFoldBand(band);
  }
}

/** Renders one band from now on; its attribute then reads `rendered`. */
export function renderBelowFoldBand(band: HTMLElement): void {
  band.style.setProperty("content-visibility", "visible");
  band.setAttribute(BELOW_FOLD_ATTRIBUTE, "rendered");
}
